// PRELOADER
const preloader = document.getElementById("preloader");
const site = document.getElementById("site");
let plSeen = false;
try { plSeen = sessionStorage.getItem("lv_seen") === "1"; } catch (e) {}
const plReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
if (!preloader) {
  // Preloader disabled in theme settings
  if (site) site.classList.add("visible");
} else if (plSeen || plReduce) {
  // Repeat visit this session, or user prefers less motion → skip the cinematic
  preloader.style.display = "none";
  if (site) site.classList.add("visible");
} else {
  try { sessionStorage.setItem("lv_seen", "1"); } catch (e) {}
  const plDuration = parseInt(preloader.dataset.duration, 10) || 2200;
  setTimeout(() => {
    preloader.classList.add("exit");
    if (site) site.classList.add("visible");
    setTimeout(() => { preloader.style.display = "none"; }, 950);
  }, plDuration);
}

// NAV + TICKER
const nav = document.getElementById("nav");
const ticker = document.querySelector(".ticker-wrap");
const isHome = document.body.classList.contains("template-index");
function lvOnScroll() {
  const y = window.scrollY;
  const tickerGone = y > 40;
  if (ticker) ticker.classList.toggle("hidden", tickerGone);
  // Home: nav stays transparent over the hero, turns solid after it.
  // Inner pages: nav is already solid (CSS); just lift it to the top once the ticker hides.
  if (nav) nav.classList.toggle("scrolled", isHome ? (y > window.innerHeight * 0.7) : tickerGone);
}
window.addEventListener("scroll", lvOnScroll);
lvOnScroll();

// HAMBURGER
const hamburger = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobileMenu");
hamburger.addEventListener("click", () => {
  hamburger.classList.toggle("open");
  mobileMenu.classList.toggle("open");
  document.body.style.overflow = mobileMenu.classList.contains("open") ? "hidden" : "";
});
mobileMenu.querySelectorAll("a").forEach(a => {
  a.addEventListener("click", () => {
    hamburger.classList.remove("open");
    mobileMenu.classList.remove("open");
    document.body.style.overflow = "";
  });
});

// SCROLL REVEAL
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add("visible");
      // Trigger counter if inside counter section
      const nums = e.target.querySelectorAll("[data-target]");
      nums.forEach(el => animateCounter(el));
    }
  });
}, { threshold: 0.01, rootMargin: "0px 0px -40px 0px" });
document.querySelectorAll(".reveal, .slide-up").forEach(el => obs.observe(el));

// Also observe counter section directly
const counterSection = document.querySelector(".counter-section");
if (counterSection) obs.observe(counterSection);

// COUNTER ANIMATION
function animateCounter(el) {
  const target = parseInt(el.dataset.target);
  const em = el.querySelector("em");
  if (!em || em.dataset.done) return;
  em.dataset.done = "1";
  const duration = 1800;
  const start = performance.now();
  const easeOut = t => 1 - Math.pow(1 - t, 3);
  function step(now) {
    const progress = Math.min((now - start) / duration, 1);
    const val = Math.round(easeOut(progress) * target);
    em.textContent = val.toLocaleString("uk-UA");
    if (progress < 1) requestAnimationFrame(step);
    else em.textContent = target.toLocaleString("uk-UA");
  }
  requestAnimationFrame(step);
}

// CURSOR
const dot = document.getElementById("cursor-dot");
const ring = document.getElementById("cursor-ring");
let mx = 0, my = 0, rx = 0, ry = 0;
document.addEventListener("mousemove", e => {
  mx = e.clientX; my = e.clientY;
  dot.style.left = mx + "px"; dot.style.top = my + "px";
});
(function animRing() {
  rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
  ring.style.left = rx + "px"; ring.style.top = ry + "px";
  requestAnimationFrame(animRing);
})();
document.querySelectorAll("[data-cursor='hover']").forEach(el => {
  el.addEventListener("mouseenter", () => document.body.classList.add("cursor-hover"));
  el.addEventListener("mouseleave", () => document.body.classList.remove("cursor-hover"));
});
document.querySelectorAll("[data-cursor='btn']").forEach(el => {
  el.addEventListener("mouseenter", () => document.body.classList.add("cursor-btn"));
  el.addEventListener("mouseleave", () => document.body.classList.remove("cursor-btn"));
});

// SEARCH OVERLAY
(function () {
  const toggle = document.getElementById("searchToggle");
  const overlay = document.getElementById("searchOverlay");
  const close = document.getElementById("searchClose");
  if (!toggle || !overlay) return;
  const input = overlay.querySelector(".search-input");
  function open() {
    overlay.classList.add("open");
    toggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    setTimeout(() => input && input.focus(), 120);
  }
  function hide() {
    overlay.classList.remove("open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  toggle.addEventListener("click", open);
  if (close) close.addEventListener("click", hide);
  overlay.addEventListener("click", e => { if (e.target === overlay) hide(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && overlay.classList.contains("open")) hide(); });
})();

// COLLECTION SORT
(function () {
  const sel = document.querySelector("[data-collection-sort]");
  if (!sel) return;
  sel.addEventListener("change", function () {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sel.value);
    url.searchParams.delete("page");
    window.location.href = url.toString();
  });
})();

// ═══════════ CART DRAWER + AJAX ═══════════
(function () {
  function drawer() { return document.getElementById("cartDrawer"); }
  function openCart() {
    var d = drawer(); if (!d) return;
    d.classList.add("open"); d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove("open"); d.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  window.lvOpenCart = openCart;

  function syncCount(scope) {
    var txt = (scope || document).querySelector("[data-cart-count-text]");
    var n = txt ? (parseInt(txt.textContent.trim(), 10) || 0) : 0;
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      var prev = parseInt(el.dataset.prev || el.textContent.trim(), 10) || 0;
      el.textContent = n;
      el.dataset.prev = n;
      el.classList.toggle("is-empty", n === 0);
      if (n > prev) {
        el.classList.remove("bump");
        void el.offsetWidth; // restart animation
        el.classList.add("bump");
      }
    });
  }
  syncCount();

  function renderCart(sectionsHtml) {
    var d = drawer();
    if (!d || !sectionsHtml) return;
    var temp = document.createElement("div");
    temp.innerHTML = sectionsHtml;
    var fresh = temp.querySelector("#cartDrawer");
    if (!fresh) return;
    var wasOpen = d.classList.contains("open");
    d.innerHTML = fresh.innerHTML;
    if (wasOpen) { d.classList.add("open"); d.setAttribute("aria-hidden", "false"); }
    syncCount(d);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ----- Add to cart (product form) -----
  var form = document.querySelector(".lv-product-form, [data-product-form]");
  if (form) {
    form.addEventListener("submit", function (e) {
      // Drawer not present → allow native submit (full page)
      if (!drawer()) return;
      // Let Shopify dynamic checkout ("Купити зараз") proceed natively
      if (e.submitter && !e.submitter.hasAttribute("data-add-to-cart")) return;
      e.preventDefault();
      var btn = form.querySelector("[data-add-to-cart]");
      var label = btn.querySelector("[data-add-text]");
      var original = label ? label.textContent : "";
      if (btn.disabled) return;
      btn.disabled = true; if (label) label.textContent = "Додаємо…";
      var id = form.querySelector("[name='id']").value;
      var qty = parseInt((form.querySelector("[name='quantity']") || {}).value || 1, 10);
      postJSON("/cart/add.js", { items: [{ id: id, quantity: qty }], sections: ["cart-drawer"], sections_url: window.location.pathname })
        .then(function (res) {
          if (res.status) { // error object
            if (label) label.textContent = res.description || "Помилка";
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 2000);
            return;
          }
          if (res.sections) renderCart(res.sections["cart-drawer"]);
          if (label) label.textContent = "Додано ✓";
          openCart();
          setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1500);
        })
        .catch(function () { btn.disabled = false; if (label) label.textContent = original; });
    });
  }

  // ----- Add "set" (current product + companion) in one click -----
  document.addEventListener("click", function (e) {
    var sb = e.target.closest("[data-set-add]");
    if (!sb || !drawer()) return;
    e.preventDefault();
    if (sb.disabled || sb.dataset.busy) return;
    var compId = sb.getAttribute("data-variant-id");
    var curEl = document.getElementById("ProductVariantId");
    var curId = curEl ? curEl.value : null;
    var items = [];
    if (curId) items.push({ id: curId, quantity: 1 });
    if (compId) items.push({ id: compId, quantity: 1 });
    if (!items.length) return;
    var txt = sb.querySelector(".lv-set-add-txt");
    var orig = txt ? txt.textContent : "";
    sb.dataset.busy = "1";
    if (txt) txt.textContent = "…";
    postJSON("/cart/add.js", { items: items, sections: ["cart-drawer"], sections_url: window.location.pathname })
      .then(function (res) {
        if (res.status) { if (txt) txt.textContent = orig; delete sb.dataset.busy; return; }
        if (res.sections) renderCart(res.sections["cart-drawer"]);
        sb.classList.add("is-done");
        if (txt) txt.textContent = "✓";
        openCart();
        setTimeout(function () { sb.classList.remove("is-done"); if (txt) txt.textContent = orig; delete sb.dataset.busy; }, 1700);
      })
      .catch(function () { if (txt) txt.textContent = orig; delete sb.dataset.busy; });
  });

  // ----- Delegated drawer controls -----
  document.addEventListener("click", function (e) {
    if (e.target.closest(".nav-cart") && drawer()) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    var minus = e.target.closest("[data-cart-minus]");
    var plus = e.target.closest("[data-cart-plus]");
    var remove = e.target.closest("[data-cart-remove]");
    if (minus || plus || remove) {
      var key = (minus || plus || remove).dataset.key;
      var input = document.querySelector("[data-cart-qty][data-key='" + key + "']");
      var current = input ? parseInt(input.value, 10) : 1;
      var next = remove ? 0 : (plus ? current + 1 : current - 1);
      changeLine(key, next);
    }
  });
  document.addEventListener("change", function (e) {
    var qty = e.target.closest("[data-cart-qty]");
    if (qty) changeLine(qty.dataset.key, Math.max(0, parseInt(qty.value, 10) || 0));
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer() && drawer().classList.contains("open")) closeCart();
  });

  function changeLine(key, quantity) {
    postJSON("/cart/change.js", { id: key, quantity: quantity, sections: ["cart-drawer"], sections_url: window.location.pathname })
      .then(function (res) { if (res.sections) renderCart(res.sections["cart-drawer"]); });
  }
})();

// ═══════════ PRODUCT: variants, quantity, gallery ═══════════
(function () {
  var form = document.querySelector(".lv-product-form, [data-product-form]");

  // ----- Quantity stepper (product page) -----
  var qtyInput = document.getElementById("Quantity");
  if (qtyInput) {
    var minus = form.querySelector("[data-qty-minus]");
    var plus = form.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
  }

  // ----- Variant selection -----
  if (form && window.lvProductVariants) {
    var optionSelects = Array.prototype.slice.call(form.querySelectorAll("[data-option-index]"));
    var master = document.getElementById("ProductVariantId");
    var priceEl = document.getElementById("ProductPrice");
    var addBtn = document.getElementById("AddToCart");
    var addText = addBtn ? addBtn.querySelector("[data-add-text]") : null;

    if (optionSelects.length) {
      var updateVariant = function () {
        var opts = optionSelects.map(function (s) { return s.value; });
        var variant = window.lvProductVariants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!variant) { if (addText) addText.textContent = "Недоступна комбінація"; addBtn.disabled = true; return; }
        if (master) master.value = variant.id;
        var opt = master ? master.querySelector("option[value='" + variant.id + "']") : null;
        if (!variant.available) { addBtn.disabled = true; if (addText) addText.textContent = "Немає в наявності"; }
        else { addBtn.disabled = false; if (addText) addText.textContent = "Додати в кошик"; }
        if (opt && priceEl) {
          if (opt.dataset.onSale === "true") {
            priceEl.innerHTML = '<span class="lv-price-sale">' + opt.dataset.price + '</span> <s class="lv-price-was">' + opt.dataset.compare + '</s>';
          } else {
            priceEl.textContent = opt.dataset.price;
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      };
      optionSelects.forEach(function (s) { s.addEventListener("change", updateVariant); });
    }
  }

  // ----- Gallery thumbnail switching -----
  var mainImg = document.getElementById("ProductMainImage");
  var thumbs = document.querySelectorAll(".lv-product-thumb");
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImg) return;
      mainImg.classList.add("is-swapping");
      var next = new Image();
      next.onload = function () {
        mainImg.src = thumb.dataset.full;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
        mainImg.classList.remove("is-swapping");
      };
      next.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
    });
  });
})();

/* ── Category cards ──
   Desktop: preview list reveals on hover (pure CSS).
   Mobile/touch: a single tap navigates straight to the category page
   (the landing there shows sub-category tiles), so no tap-to-reveal trap. ── */

// ═══════════ MAGNETIC MICRO-PULL (hover devices only) ═══════════
(function () {
  var canHover = window.matchMedia("(hover: hover)").matches;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!canHover || reduce) return;

  var targets = document.querySelectorAll(".btn-light, .btn-ghost-hero, .nav-icon-btn, .view-all, .newsletter-btn");
  targets.forEach(function (el) {
    el.setAttribute("data-magnetic", "");
    var strength = el.classList.contains("nav-icon-btn") ? 6 : 10;
    el.addEventListener("mousemove", function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - (r.left + r.width / 2)) / r.width;
      var y = (e.clientY - (r.top + r.height / 2)) / r.height;
      el.style.transform = "translate(" + (x * strength).toFixed(1) + "px," + (y * strength).toFixed(1) + "px)";
    });
    el.addEventListener("mouseleave", function () { el.style.transform = ""; });
  });
})();

// ═══════════ IMAGE BLUR-UP (premium load-in for product cards) ═══════════
(function () {
  function reveal(img) { img.classList.add("is-loaded"); }
  document.querySelectorAll(".lv-card-img img").forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) reveal(img);
    else img.addEventListener("load", function () { reveal(img); });
  });
})();

// ═══════════ CARD SCROLL-REVEAL (staggered) ═══════════
(function () {
  var grids = document.querySelectorAll(".lv-grid, .lv-cats");
  if (!grids.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    grids.forEach(function (g) { g.classList.add("cards-in"); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("cards-in"); obs.unobserve(e.target); } });
  }, { threshold: 0.08 });
  grids.forEach(function (g) { obs.observe(g); });
})();

// ═══════════ QUANTITY POP ═══════════
(function () {
  var q = document.getElementById("Quantity");
  if (!q) return;
  function pop() { q.classList.remove("is-pop"); void q.offsetWidth; q.classList.add("is-pop"); }
  var form = document.querySelector(".lv-product-form, [data-product-form]");
  if (!form) return;
  var m = form.querySelector("[data-qty-minus]"), p = form.querySelector("[data-qty-plus]");
  if (m) m.addEventListener("click", pop);
  if (p) p.addEventListener("click", pop);
})();

// ═══════════ STICKY ADD-TO-CART (mobile) ═══════════
(function () {
  var bar = document.querySelector("[data-sticky-atc]");
  var addBtn = document.getElementById("AddToCart");
  if (!bar || !addBtn) return;
  var sticky = bar.querySelector("[data-sticky-add]");
  if (sticky) sticky.addEventListener("click", function () { addBtn.click(); });
  var obs = new IntersectionObserver(function (entries) {
    var show = entries[0].boundingClientRect.bottom < 0;
    bar.classList.toggle("show", show);
    document.body.classList.toggle("lv-atc-on", show);
  }, { threshold: 0 });
  obs.observe(addBtn);
})();